<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">BRANCHES</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>

                    <v-layout>
                        <v-container class="pr-0">
                            <v-flex xs6 right>
                                <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>
                    <br><br>
                    <v-spacer></v-spacer>
                    <v-flex xs6 right v-if="activeBranches.length > 0">
                        <v-btn color="red accent-4" dark @click="resetDialog=true">SYNC<v-icon>sync</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs6 right v-else>
                        <v-btn color="red accent-4" dark @click="fetchNetsuiteBranches()">
                            SYNC<v-icon>sync</v-icon>
                        </v-btn>
                    </v-flex>
                </v-container>
            </v-parallax>

            <v-layout>
                <v-container>
                    <v-layout>
                        <v-spacer></v-spacer>
                    </v-layout>

                <v-flex xs12>
                    <br>
                    <v-data-table :headers="headers" :items="activeBranches" :search="search"  class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.subsidiary }}</td>
                            <td class="text-xs-left">{{ props.item.businessUnit }}</td>
                            <td class="text-xs-left">{{ props.item.cluster }}</td>
                            <td class="text-xs-center">{{ props.item.branchCode }}</td>
                            <td class="text-xs-left">{{ props.item.address }}</td>
                            <td class="text-xs-left">{{ props.item.latitude }}</td>
                            <td class="text-xs-left">{{ props.item.longitude }}</td>
                            <!-- <td class="text-xs-left">
                                <v-edit-dialog :return-value.sync="props.item.latitude" large lazy persistent @save="saveConfig('latitude',props.item.latitude,props.item.branchCode)">
                                    <div>{{ props.item.latitude}}</div>
                                    <template v-slot:input>
                                        <div class="mt-3 title">Update Coordinates</div>
                                    </template>
                                    <template v-slot:input>
                                        <v-text-field v-model="props.item.latitude" label="Latitude" single-line counter autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-xs-left">
                                <v-edit-dialog :return-value.sync="props.item.longitude" large lazy persistent @save="saveConfig('longitude',props.item.longitude,props.item.branchCode)">
                                    <div>{{ props.item.longitude}}</div>
                                    <template v-slot:input>
                                        <div class="mt-3 title">Update Coordinates</div>
                                    </template>
                                    <template v-slot:input>
                                        <v-text-field v-model="props.item.longitude" label="Longitude" single-line counter autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td> -->
                            <!-- <td class="text-xs-left">
                               <v-btn color="primary" small dark @click="showBranchServices(props.item)"> Show Services</v-btn>
                            </td> -->
                            <!-- <td class="text-xs-center">
                                <v-icon small>edit</v-icon>
                            </td> -->
                            
                            <td class="text-xs-left">
                                <v-edit-dialog :return-value.sync="props.item.status" large lazy persistent @save="saveConfig(props.item.status,props.item.branchCode)">
                                    <div>{{ props.item.status}}</div>
                                    <template v-slot:input>
                                        <div class="mt-3 title">Status</div>
                                    </template>
                                    <template v-slot:input>
                                        <v-select v-model="props.item.status" :items="statuses" label="Status" single-line counter autofocus></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                        </template> 

                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Branch Available
                            </v-alert>
                        </template>

                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
                </v-container>
            </v-layout>

            <v-layout row justify-center>
                <v-dialog v-model="resetDialog" max-width="500px">
                    <v-card>
                    <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                    <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to reset the current list of Business Units? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to reset the list of current business units that will load the default data of business units.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="resetDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="(resetDialog=false),fetchNetsuiteBranches()">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                    </v-card>
                </v-dialog>

                 <v-dialog v-model="servicesDialog">
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="servicesDialog=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{selectedBranch.businessUnit}} Services</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card>
                        <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 class="pr-0">
                                <v-layout wrap><v-spacer></v-spacer>
                                    <v-flex xs8>
                                        <v-text-field class="subheading font-weight-regular pb-3 pt-0" v-model="searchService" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                    </v-flex>
                                </v-layout>
                                
                                <v-data-table :headers="serviceHeader"
                                :items="services" item-key="jobCode" :search="searchService" class="elevation-1">
                                    <template v-slot:items="props">
                                        <td>{{ props.item.jobCode }}</td>
                                        <td>{{ props.item.classification.text }}</td>
                                        <td>{{ props.item.category.text }}</td>
                                        <td>{{ props.item.name }}</td>
                                        <td>{{ props.item.description.text }}</td>
                                        <td class="text-xs-left">{{ props.item.displayName }}</td>
                                        <td class="text-xs-left">{{ props.item.displayDescription }}</td>
                                        <td class="text-xs-left">{{ props.item.time }}</td>
                                        <td class="justify-center">
                                            <v-icon small @click="requestForRemoval(props.item)">delete</v-icon>
                                        </td>
                                    </template>

                                    <template v-slot:no-data>
                                        <v-alert :value="true" color="grey">
                                            No Service Available
                                        </v-alert>
                                    </template>

                                    <template v-slot:no-results>
                                        <v-alert :value="true" color="error" icon="warning">
                                            Your search for "{{ searchService }}" found no results.
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex> 
                        </v-layout>
                        </v-container>
                    </v-card>
                </v-dialog> 

                <v-dialog v-model="removeDialog" max-width="500px">
                    <v-card>
                        <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                            <v-spacer></v-spacer>
                            <v-container>
                                <v-layout><br>
                                <h4 class="title font-weight-medium">Are you sure you want to remove this service in the Branch? </h4>
                                </v-layout>
                            </v-container>
                        </v-parallax>

                        <v-container grid-list>
                            <v-card-text class="subheading font-weight-regular">
                            You are about to remove the service details in the list.
                            </v-card-text>
                            <v-card-text class="subheading font-weight-regular">
                            Do you want to proceed?
                            </v-card-text>

                            <v-card-actions class="justify-center">
                                <v-btn dark color="red accent-4" @click="removeDialog=false">NO</v-btn>
                                <v-btn dark color="blue darken-4" @click="removeBranchService()">YES</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="showProgress" persistent width="300">
                    <v-card color="primary">
                        <v-card-text class="subheading white--text"> {{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true"
                                :size="70" :width="5" color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-snackbar v-model="snackbar" bottom right :color="snackbarColor">{{ snackbarMessage }} 
                    <v-btn dark small flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'
import { stage } from '../../appConfig'

export default {
    data() {
        return {
            netsuiteBusinessUnit: [],
            activeBranches: [],
            activeBranchCount: 0,
            headers: [
                { text: 'Subsidiary', align: 'left', sortable: true, value: 'subsidiary'},
                { text: 'Branch Name', align: 'left', sortable: true, value: 'businessUnit'},
                { text: 'Cluster', value: 'cluster',  sortable: true  },
                { text: 'Branch Code', value: 'branchCode',  sortable: true  },
                { text: 'Address', value: 'address',  sortable: false  },
                { text: 'Latitude', value: 'latitude',  sortable: false  },
                { text: 'Longitude', value: 'longitude',  sortable: false  },
                { text: 'Active', value: 'status',  sortable: false, align: 'center'  },
            ],
            search: "",
            snackbar: false,
            snackbarColor: "",
            snackbarMessage: "",
            progressMessage: "",
            showProgress: false,
            dialog: false,
            disabledColor: "grey",
            activeColor: "red",
            resetDialog: false,
            expand: false,
            servicesDialog: false,
            serviceHeader: [
                { text: 'Job Code', align: 'left', sortable: true, value: 'jobCode'},
                { text: 'Classification', value: 'classification',  sortable: true  },
                { text: 'Category', value: 'category',  sortable: true },
                { text: 'Name', value: 'name',  sortable: true  },
                { text: 'Description', value: 'description',  sortable: false },
                { text: 'Display Name', value: 'displayName',  sortable: false },
                { text: 'Display Description', value: 'displayDescription', sortable: false },
                { text: 'Time Rate(minutes)', value: 'timeRate',  sortable: false },
                { text: 'Action', value: 'jobCode', sortable: false }
            ],
            searchService: "",
            services: [],
            selectedBranch: {},
            removeDialog: false,
            forRemoval: "",
            statuses: [true,false]
        }
    },

    computed : {
        ...mapGetters(["user"]),
    },

    mounted() {
        let self = this
        this.configuredBusinessUnits()
    },

    methods: {
        async fetchNetsuiteBranches() {
            let self = this
            self.progressMessage = "Fetching data from Netsuite..."
            self.showProgress = true
            self.netsuiteBusinessUnit = []
            self.$axios.defaults.headers.common['Authorization']=`NSJ ${self.$consumerKey}&${self.$consumerSecret}`
            self.$axios.defaults.headers.common['ns-token']= self.$tokenId
            self.$axios.defaults.headers.common['ns-token-secret']= self.$tokenSecret
            self.$axios.defaults.headers.common['Content-Type']= self.$contentType
            
            await self.$axios.get(self.$branchMaster).then(function(res){
                self.netsuiteBusinessUnit = res.data.data
            }).then(function() {
                self.clone()
            }).catch(function(error) {
                console.error("Error getting document: ", error)
                self.showProgress = false
                self.snackbarColor = "error"
                self.snackbarMessage = "Error fetching document"
                self.snackbar = true
            })
        },

        clone() {
            let self = this
            let countRetail = 0
            self.netsuiteBusinessUnit.forEach(function(data) {
                let branchCode = {
                    'HO_': 'Head-Office',
                    'TCM_MM_': 'Transcycle ',
                    'TCM_NL_': 'Transcycle ',
                    'TCM_SL_': 'Transcycle ',
                    'TCM_VZ_': 'Transcycle ',
                    'TCM_MN_': 'Transcycle ',
                    'YMH_MM_': 'Transcycle ',
                    'PCI_MM_': 'Powercycle ',
                    'PCI_NL_': 'Powercycle ',
                    'PCI_SL_': 'Powercycle ',
                    'PCI_VZ_': 'Powercycle ',
                    'PCI_MN_': 'Powercycle ',
                }

                for (let key in branchCode) {
                    let re = new RegExp(key, 'gi')
                    data.values.name = data.values.name.replace(re, branchCode[key])
                    data.values["address.address"] = data.values["address.address"].replace(re, branchCode[key])
                }

                db.collection("Branches"+self.$stage).doc(data.values.custrecord_loc_bc).set({
                    "id": data.id,
                    "branchCode": data.values.custrecord_loc_bc,
                    "businessUnit": data.values.name,
                    "subsidiary": data.values.subsidiary,
                    "latitude": data.values.latitude,
                    "longitude": data.values.longitude,
                    "address": data.values["address.address"],
                    "cluster": data.values.custrecord_loc_lc[0].text,
                    "status": true
                }).then(function() {
                    countRetail ++
                    if (countRetail == self.netsuiteBusinessUnit.length) {
                        self.showProgress = false
                        self.progressMessage = ""
                        self.configuredBusinessUnits()
                    }
                }).catch(function(error) {
                    console.error("Error writing document: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "Error writing document"
                    self.snackbar = true
                })
            })
        },

        async configuredBusinessUnits() {
            let self = this
            self.activeBranches = []
            self.activeBranchCount = 0
            self.progressMessage = "Loading..."
            self.showProgress = true
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        self.activeBranches.push(doc.data())
                    })
                }).then(function(){
                    self.showProgress = false
                    self.activeBranchCount = self.activeBranches.length
                    self.activeBranches = _.sortBy(self.activeBranches, o => o.cluster)
                }).catch(function(error) {
                    console.error("Error getting branches: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "Error fetching branches"
                    self.snackbar = true
                })
        },

        // saveConfig(type,val,branchCode) {
        //     let self = this
        //     switch (type) {
        //         case "latitude":
        //             db.collection("Branches"+self.$stage).doc(branchCode).update({
        //                 latitude: val
        //             })
        //             break;
        //         case "longitude":
        //             db.collection("Branches"+self.$stage).doc(branchCode).update({
        //                 longitude: val
        //             })
        //             break;
        //         default:
        //             console.log('Sorry, we are out of ' + type + '.');
        //     }
        // },

        saveConfig(val,branchCode) {
            let self = this
            db.collection("Branches"+self.$stage).doc(branchCode).update({
                status: val
            })
        },

        showBranchServices(data) {
            let self = this
            let lists = []
            self.services = []
            db.collection("ServiceGallery"+self.$stage).doc(data.branchCode).get()
                .then(function(doc) {
                    if (doc.exists) {
                        lists = doc.data().Service
                    }
                }).then(function(){
                    if (lists.length > 0) {
                        lists.forEach(function(id){
                            db.collection("Services"+self.$stage).doc(id).get()
                            .then(function(doc) {
                                self.services.push(doc.data())
                            })
                        })
                    }
                    self.selectedBranch = data
                    self.servicesDialog = true
                }).catch(function(error) {
                    console.error("Error matching services: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "Error matching services"
                    self.snackbar = true
                })
        },

        requestForRemoval(data) {
            let self = this
            self.removeDialog = true
            self.forRemoval = data.jobCode
        },

        removeBranchService() {
            let self = this
            let serviceRef = []
            let count = 0
            self.progressMessage = "Saving..."
            self.showProgress = true
            self.services = self.services.filter(item => item.jobCode !== self.forRemoval)
            self.services.forEach(function(res) {
                serviceRef.push(res.jobCode)
                count ++
            })
            
            if (self.services.length === count) {
                db.collection("ServiceGallery"+self.$stage).doc(self.selectedBranch.branchCode)
                .update({
                    Service: serviceRef
                }).then(function() {
                    self.removeDialog = false
                    self.servicesDialog = false
                    self.showProgress = false
                }).catch(function(error) {
                    console.error("Error writing document: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "Error writing document"
                    self.snackbar = true
                })
            }
        }
    },

    watch: {

    }

}
</script>

<style scoped>

</style>